import {z} from 'zod';

export const NotificationConfigurationResourceTypeSchema = z.enum([
  'default',
  'airdrop',
  'perk',
  'digitalAssetCollection',
  'journey',
  'store',
]);

export type NotificationConfigurationResourceType = z.infer<
  typeof NotificationConfigurationResourceTypeSchema
>;
